import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import Mask from '../../../../../../../../utils/Mask';
import { connect } from 'react-redux';

import Icon from '../../../../../../../../components/Icon';
import { ContentWrapper, InfoTitle, SectionContainer, ShippingCompanyIcon, SliderTitle, StyledDrawer, TitleWrapper, TransportInfoWrapper } from '../styles';
import DeliverySection from './DeliverySection';
import RecipientSection from './RecipientSection';

const DRAWER_ELEMENT_NAME = 'nf-details-drawer';

const NfDetailWrapper = styled.div`
  padding: 24px 0;
`;

const DetailTitle = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: -8px;
  margin-bottom: 24px;
  color: var(--luft-primary);
  gap: 8px;

  &:hover {
    opacity: 0.7;
  }

  i {
    font-size: 24px;
  }
`;

const LinkToTracking = styled.a`
  text-decoration: none;
  color: var(--light-blue);

  &:hover {
    opacity: 0.7;
  }
`;

const DriverAndRecipientContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const DetailByNf = ({ show, data, onDismiss, ...props }) => {
  const [shouldShow, setShouldShow] = useState(show);
  const setTimeoutRef = useRef(null);

  useEffect(() => {
    clearTimeout(setTimeoutRef.current);

    if (show) {
      setShouldShow(true);
    } else {
      requestAnimationFrame(() => {
        setTimeoutRef.current = setTimeout(() => {
          setShouldShow(false);
        }, 300);
      });
    }
  }, [shouldShow, show]);

  return shouldShow && data ? (
    <StyledDrawer data-name={DRAWER_ELEMENT_NAME} open={show} {...props}>
      <NfDetailWrapper>
        <SectionContainer>
          <DetailTitle
            style={{ curson: 'pointer' }}
            onClick={() => onDismiss()}
          >
            <Icon name="keyboard_arrow_left" />
            <SliderTitle noMargin>{`${data.nf}-${data.nfGroup}`}</SliderTitle>
          </DetailTitle>
        </SectionContainer>
        <DriverAndRecipientContainer>
          <RecipientSection recipientInfo={data} />
          <DeliverySection driverInfo={data} />
        </DriverAndRecipientContainer>
        <SectionContainer bordered borderColor="#229DEC">
          <LinkToTracking>
            <NavLink
              to={`/u/tracking/${data.nf}`}
              style={{ textDecoration: 'none' }}
            >
              Ver mais detalhes dessa nota no Tracking Integrado
            </NavLink>
          </LinkToTracking>
        </SectionContainer>
        <SectionContainer>
          <ContentWrapper bordered noPadding>
            <TransportInfoWrapper>
              <TitleWrapper>
                <InfoTitle color="#263465">
                  Transportadora
                </InfoTitle>
                <InfoTitle medium color="#292F36">
                  {data.shippingCompany.corporateName || Mask.cnpj(data.shippingCompany.cnpj || '')}
                </InfoTitle>
              </TitleWrapper>
              {
                data?.shippingCompany?.icon ? 
                  <ShippingCompanyIcon src={data.shippingCompany?.icon} alt='Logo' />
                  : null
              }
            </TransportInfoWrapper>
          </ContentWrapper>
        </SectionContainer>
      </NfDetailWrapper>
    </StyledDrawer>
  ) : null;
};

const mapStateToProps = state => ({  userType: state.auth.userType });

export default connect(mapStateToProps)(DetailByNf);
